import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { LoggerService } from './services/logger.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  cname = 'AppComponent';
  constructor(private _router: Router, private loggerService: LoggerService) {
    window.addEventListener('storage', this.storageEventHandler.bind(this));
  }

  storageEventHandler(evt) {
    const functionName = this.cname + '.storageEventHandler';

    try {
      this.loggerService.logger.logTrace(`${functionName} - A storage event was received for the following storage key: ${evt.key} `);

      if (evt.key === 'SAMLLoginStamp') {
        this.loggerService.logger.logTrace(`${functionName} - SAMLLoginStamp storage event was received, reloading the window.`);
        window.location.reload();
      } else if (evt.key === 'ExternalFrameLoginInitiate') {
        this.loggerService.logger.logTrace(
          `${functionName} - An ExternalFrameLoginInitiate storage event was received, the ExternalFrameLoginProcessed storage key will be set and the window will be reloaded.`
        );
        localStorage.setItem('ExternalFrameLoginProcessed', evt.newValue);
        window.location.reload();
      } else if (evt.key === 'ForceLogoutRefresh' && !this._router.url.startsWith('/login') && !window.location.href.includes('AgentType=Login')) {
        this.loggerService.logger.logTrace(`${functionName} - ForceLogoutRefresh storage event was received, reloading the window.`);
        window.location.reload();
      } else if (evt.key === 'LoginForceLogoutRefresh') {
        this.loggerService.logger.logTrace(`${functionName} - LoginForceLogoutRefresh storage event was received, a window reload is not required.`);
      }
    } catch (e) {
      this.loggerService.logger.logError(`${functionName} Error processing storage event: ${JSON.stringify(e)}`);
    }
  }

  ngOnInit(): void {
    let routeParams: string;
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && routeParams) {
        window.history.replaceState({}, '', `${location.pathname}?${routeParams}`);
      } else if (event instanceof NavigationStart) {
        const params = event.url.split('?');
        if (params && params.length >= 2) {
          routeParams = params[1];
        }
      }
    });
  }
}
